export default __webpack_public_path__ + "pgnv-assets/3bbe863851bc321e667ce70b504db5b6.png";